import React, {Component} from "react";
import {Alert, Carousel, FormControl, Modal} from "react-bootstrap";
import Axios from 'axios';
import {MapContainer} from "./Map/Map";
import SelectedBoard from "./SelectedBoard";
import loadingSvg from "../images/loading.svg";
import {Link} from "react-router-dom";
import Footer from "../Footer";
import {ReactComponent as EditSvg} from "../images/edit-regular.svg";
import {GetUser} from "../helpers/User";
import {
    boardMatchesSearch, 
    convertStateToParams, 
    parseExistingParams, 
    GetBoardsGroupedByUnit, 
    GetFormatCounts, 
    GetLayerCounts,
    GetMarketCounts,
    GetSortedVendorIds,
    GetStatusCounts,
    updateFilters,
    getUrlExtension, 
    GetVendorCounts,
    IsUserOwner,
    IsUserPrimaryOwner
} from "../helpers/Helpers";
import BoardCardTreeWrapper from "./BoardCardTreeWrapper";
import BoardCard from "./BoardCard";

const defaultFilters = {
    status: [],
    "media format": [],
    market: [],
    vendor: [],
    layer: [],
};

export default class GetCampaignPage extends Component{
    state = {
        showPOIs: true,
        filters: JSON.parse(JSON.stringify(defaultFilters)),
    };

    constructor(props) {
        super(props)
        this.selectBoard = this.selectBoard.bind(this)
        this.centerMap = this.centerMap.bind(this)
        this.toggleCompliancePins = this.toggleCompliancePins.bind(this)
        this.togglePOIsPins = this.togglePOIsPins.bind(this)
        this.turnOffPins = this.turnOffPins.bind(this)
        this.updateBoard = this.updateBoard.bind(this)
        this.toggleFullScreenImage = this.toggleFullScreenImage.bind(this)
    }

    componentDidMount() {
        GetUser().then((user=>{
            this.setState({user:user})
        }))
        // setTimeout(()=>{
        this.getCampaignAPI();
        this.getOverlayAPI();
        this.setStateFromQueryParams(this.props.location.search);
        // }, 1000);
    }

    componentDidUpdate(prevProps) {
        const oldQueryParams = prevProps.location.search;
        const newQueryParams = this.props.location.search;

        if (oldQueryParams !== newQueryParams) {
            this.setStateFromQueryParams(newQueryParams);
        }
    }

    toggleCompliancePins() {
        if(this.state.showCompliance){
            this.setState({showCompliance: false, showPOIs:false})
        }else{
            this.setState({showCompliance: true, showPOIs:false})
        }
    }

    togglePOIsPins() {
        if(this.state.showPOIs){
            this.setState({showPOIs: false, showCompliance: false})
        }else{
            this.setState({showPOIs: true, showCompliance: false})
        }
    }

    turnOffPins(){
        this.setState({showCompliance:false,showPOIs:false});
    }


    getCampaignAPI(){
        let campaignId = this.props.match.params.campaignId;
        // let campaignId = this.props.match.params.campaignId;
        Axios.get(process.env.REACT_APP_BACKEND_URL+"/campaign/"+campaignId).then((response) => {
            if(response.data.message === "still looking"){
                setTimeout(()=>{
                    this.getCampaignAPI();
                },1000);
            }else{
                let campaign = response.data.campaign;
                console.log(campaign)
                if(campaign.totalBoards > campaign.boardsUploaded){
                    setTimeout(()=>{
                        this.getCampaignAPI();
                    },1000);
                }
                let sortedVendorIds = GetSortedVendorIds(campaign);
                let groupedBoards = GetBoardsGroupedByUnit(campaign)
                this.setState({
                    campaign,
                    sortedVendorIds,
                    groupedBoards,
                });
            }
        }).catch(error => {
            if(error && error.response){
                this.setState({error: {
                        title: "Unable to Fetch Campaign!",
                        body: error.response.data.message,
                    }});
            }
        });
    }

    toggleFullScreenImage(){
        this.setState({fullScreenImg:!this.state.fullScreenImg});
    }
    getOverlayAPI(){
        let campaignId = this.props.match.params.campaignId;
        // let campaignId = this.props.match.params.campaignId;
        Axios.get(process.env.REACT_APP_BACKEND_URL+"/campaign/"+campaignId+"/overlays").then(async (response) => {
            if(response.data.message === "still looking"){
                setTimeout(()=>{
                    this.getOverlayAPI();
                },1000);
            }else{
                let campaign = response.data.campaign;
                if(campaign.totalBoards > campaign.boardsUploaded){
                    setTimeout(()=>{
                        this.getOverlayAPI();
                    },1000);
                }
                this.setState({overlays: response.data.overlays,accidents:response.data.accidents});
                if(response.data.overlays.length && campaign.name.includes("Legal")||
                    campaign.name.includes("HVAC") && !this.state.accidents) {
                    this.setState({"accidents":[]});
                    let accidents = [];
                    let skip = "";
                    for(let i =0; i < 60; i++){
                        let res = await Axios.get(process.env.REACT_APP_BACKEND_URL + "/campaign/" + campaignId + "/accidents?skip="+skip)
                        console.log(res.data.accidents.length)
                        accidents.push(...res.data.accidents)
                        if(res.data.accidents.length < 10000){
                            break;
                        }
                        skip = accidents[accidents.length-1]._id
                        // console.log( accidents[accidents.length-1])
                    }
                    console.log("saving accidents to state", accidents.length)
                    this.setState({"accidents":accidents});
                }
            }
        }).catch(error => {
            if(error && error.response){
                this.setState({error: {
                        title: "Unable to Fetch Demographic Information!",
                        body: error.response.data.message,
                    }});
            }
        });
    }

    setQueryParam(key, value) {
        const params = new URLSearchParams(window.location.search);
        
        if (value) {
            params.set(key, value);
        } else {
            params.delete(key);
        }

        this.props.history.push({
            search: '?' + params.toString()
        });
    }

    /*
    * Use timeout for updating search in url params so that it's not updated on every character
    */
    updateSearch(value) {
        this.setState({
            search: value,
        });

        if (this.state.timeoutId) {
            clearTimeout(this.state.timeoutId);
        }

        const timeoutId = setTimeout(() => {
            this.setQueryParam("search", value);
            this.setState({
                timeoutId: null,
            });
        }, 1000);

        this.setState({
            timeoutId,
        });
    }

    updateFiltersInURL(key, value) {
        const existingParams = new URLSearchParams(window.location.search)
        const sidebarFormat = existingParams.get("sidebarFormat");
        const search = existingParams.get("search");
        const updatedFilters = updateFilters(this.state.filters, key, value);
        const params = new URLSearchParams(convertStateToParams({
            ...updatedFilters,
            ...(sidebarFormat ? { sidebarFormat } : {}),
            ...(search ? { search } : {}),
        }));

        this.props.history.push({
            search: '?' + params.toString()
        })
    }

    setStateFromQueryParams(queryParams) {
        const url = new URLSearchParams(queryParams);
        const parsedParams = parseExistingParams(url);
        delete parsedParams.sidebarFormat;
        delete parsedParams.search;
        this.setState({
            filters: {
                ...JSON.parse(JSON.stringify(defaultFilters)),
                ...parsedParams,
            },
            search: url.get("search"),
        });
    }

    selectBoard(vendorId){
        if(vendorId && this.state.campaign){
            let board = this.state.campaign.boards[vendorId];
            let latLon = {lat: board.lat, lon: board.lon};
            let params = new URLSearchParams(window.location.search)
            params.set("board",vendorId)
            this.props.history.push({
                search: '?'+params.toString()
            })
            let index = 0;
            for(let i = 0; i < this.state.sortedVendorIds.length; i++){
                if(this.state.sortedVendorIds[i].vendorId === vendorId){
                    index = i;
                    break;
                }
            }
            this.listedBoardsContainer.scrollTo({ top: index * 99});
            this.setState({center:latLon});
        }
        this.setState({POIs: [],compliances: []})
        if(!vendorId){
            let params = new URLSearchParams(window.location.search)
            params.delete("board")
            this.props.history.push({
                search: params.toString(),
            })
            this.setState({showCompliance:false,showPOIs:false});
        }
        setTimeout(function (){
            this.setState({hoveredId:vendorId})
            setTimeout(function (){
                this.setState({hoveredId:""})
            }.bind(this),3000)
        }.bind(this),100)
    }

    centerMap(lat, lon){
        let latLon = {lat: lat, lon: lon};
        this.setState({center:latLon});
    }

    //favorite, delete, edit board
    updateBoard(boardKey, board){
        let campaign =  this.state.campaign;
        campaign.boards[boardKey] = board;
        this.setState({campaign:campaign})
    }

    render() {
        let campaign = this.state.campaign;
        // let selectedBoard = this.state["selected_board"];
        let url = new URLSearchParams(window.location.search);
        let selectedBoard = url.get("board");
        let user = this.state.user;
        let isOwner = IsUserOwner(user, campaign);
        let isPrimaryOwner = IsUserPrimaryOwner(user, campaign);
        let statuses = GetStatusCounts(campaign ? campaign.boards: {});
        let markets = GetMarketCounts(campaign ? campaign.boards: {});
        let formats = GetFormatCounts(campaign ? campaign.boards: {});
        let vendors = GetVendorCounts(campaign ? campaign.boards: {});
        let layers = GetLayerCounts(campaign ?  campaign.boards: {});

        return <>{this.state.error && this.state.error.title? (
            <Alert style={{maxWidth:500,position:"fixed",right:0,top:0}} variant="danger"
                   onClose={()=>this.setState({error:undefined})} dismissible>
                <Alert.Heading>{this.state.error.title}</Alert.Heading>
                <p>{this.state.error.body}</p>
            </Alert>
        ) : (<></>)}
            <div>
                {campaign && campaign.boardsUploaded === campaign.totalBoards ? (
                    <>

                        {(campaign.name.includes("FOOTLOCKER") || campaign.name.includes("RR") || campaign.name.includes("RED ROCKS")) && (<div style={{position:"fixed",top:0, left:115, height:62, width: 300, background:"#515151", zIndex:10}}>
                            <img style={{ height: 32, margin: 17}} src={"https://images.squarespace-cdn.com/content/567454aa0ab377c9815745c5/1580506630948-3Y9VO3ASJY0L3C3K2YX0/Red+Rock+Logo-+Vector+white.png?format=1000w&content-type=image%2Fpng"}/>
                        </div>)}

                        <div className={"list-sidebar " +(url.get("sidebarFormat"))}>
                            <div className={"d-flex flex-column h-100"}>
                                <div className={"campaign-header"}>
                                    <h1>{campaign.name}</h1>
                                    <p>{FormatDate(campaign.startDate)} - {FormatDate(campaign.endDate)}</p>
                                    {isOwner ?
                                        <Link target={"_blank"} to={`/campaigns/${campaign._id}/edit-campaign`} className={"header-edit"}><EditSvg/></Link>
                                        : <></>
                                    }
                                    <div className={"d-flex"} style={{alignItems:"center"}}>
                                        <div style={{flex:"0 70px"}}
                                             onClick={()=>this.setState({showFilterDropdown:!this.state.showFilterDropdown})}
                                             className={"text-center"} role={"button"}>
                                            {this.state.showFilterDropdown ? "-" : "+"} Filter
                                        </div>
                                        <div className={"flex-grow-1"}>
                                            <FormControl
                                                style={{borderRadius:0}}
                                                placeholder="Search..."
                                                aria-label="Search..."
                                                aria-describedby="basic-addon2"
                                                value={this.state.search}
                                                onChange={e => this.updateSearch(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {this.state.showFilterDropdown &&
                                    <div className={"position-absolute px-2 filter-dropdown"}>
                                        {Object.keys(layers).length &&
                                            <>
                                                <div className={"header"}>Layers</div>
                                                <div>
                                                    {Object.keys(layers).map((layer)=>{
                                                        return  <div className={"mr-3 d-inline-block"}>
                                                            <input type="checkbox" name="status" value={layer}
                                                                   checked={this.state.filters["layer"].includes(layer)}
                                                                   onClick={this.updateFiltersInURL.bind(this, "layer", layer)}
                                                            />
                                                            <label className={"ml-1 text-capitalize"}>{layer && layer !== "undefined" ? layer : "None"} ({layers[layer]})</label>
                                                        </div>
                                                    })}
                                                </div>
                                                <hr className={"m-0"}/>
                                            </>
                                        }
                                        {Object.keys(statuses).length &&
                                            <>
                                                <div className={"header"}>Status</div>
                                                <div>
                                                    {Object.keys(statuses).map((status)=>{
                                                        return  <div className={"mr-3 d-inline-block"}>
                                                            <input type="checkbox" name="status" value={status}
                                                                   checked={this.state.filters["status"].includes(status)}
                                                                   onClick={this.updateFiltersInURL.bind(this, "status", status)}
                                                            />
                                                            <label className={"ml-1 text-capitalize"}>{status && status !== "undefined" ? status : "None"} ({statuses[status]})</label>
                                                        </div>
                                                    })}
                                                </div>
                                                <hr className={"m-0"}/>
                                            </>
                                        }
                                        {Object.keys(formats).length &&
                                            <>
                                                <div className={"header"}>Media Format</div>
                                                <div>
                                                    {Object.keys(formats).map((format)=>{
                                                        return  <div className={"mr-3 d-inline-block"}>
                                                            <input type="checkbox" name="format"
                                                                   checked={this.state.filters["media format"].includes(format)}
                                                                   onClick={this.updateFiltersInURL.bind(this, "media format", format)}
                                                                   value={format}/>
                                                            <label className={"ml-1 text-capitalize"}>{format} ({formats[format]})</label>
                                                        </div>
                                                    })}
                                                </div>
                                                <hr className={"m-0"}/>
                                            </>
                                        }
                                        {Object.keys(markets).length &&
                                            <>
                                                <div className={"header"}>Market</div>
                                                <div>
                                                    {Object.keys(markets).map((market)=>{
                                                        return  <div className={"mr-3 d-inline-block"}>
                                                            <input type="checkbox" name="status" value={market}
                                                                   checked={this.state.filters["market"].includes(market)}
                                                                   onClick={this.updateFiltersInURL.bind(this, "market", market)}
                                                            />
                                                            <label className={"ml-1 text-capitalize"}>{market} ({markets[market]})</label>
                                                        </div>
                                                    })}
                                                </div>
                                                <hr className={"m-0"}/>
                                            </>
                                        }
                                        {Object.keys(vendors).length &&
                                            <>
                                                <div className={"header"}>Vendor</div>
                                                <div>
                                                    {Object.keys(vendors).map((vendor)=>{
                                                        return  <div className={"mr-3 d-inline-block"}>
                                                            <input type="checkbox" name="status" value={vendor}
                                                                   checked={this.state.filters["vendor"].includes(vendor)}
                                                                   onClick={this.updateFiltersInURL.bind(this, "vendor", vendor)}
                                                            />
                                                            <label className={"ml-1 text-capitalize"}>{vendor} ({vendors[vendor]})</label>
                                                        </div>
                                                    })}
                                                </div>
                                                <hr className={"m-0"}/>
                                            </>
                                        }
                                    </div>}
                                {campaign.boards && this.state.groupedBoards ?
                                    <div className={"board-card-container"} ref={(el)=>{this.listedBoardsContainer=el}}>
                                        {this.state.sortedVendorIds.map((b, index) =>
                                            <>
                                                {(url.get("sidebarFormat") === "rows" || !url.get("sidebarFormat")) ?
                                                    <>
                                                        {this.state.groupedBoards[b.vendorId] &&
                                                            boardMatchesSearch(this.state.groupedBoards[b.vendorId], this.state.search, this.state.filters) ?
                                                            <BoardCardTreeWrapper
                                                                selectBoard={this.selectBoard}
                                                                onHover={(id) => { this.setState({ hoveredId: id }) }}
                                                                leaveHover={(id) => { if (this.state.hoveredId === id) this.setState({ hoveredId: "" }) }}
                                                                boardKey={b.vendorId}
                                                                isOwner={isOwner}
                                                                updateBoard={this.updateBoard}
                                                                sidebarFormat={url.get("sidebarFormat")}
                                                                centerMap={this.centerMap}
                                                                key={index}
                                                                campaign={campaign}
                                                                board={this.state.groupedBoards[b.vendorId]}
                                                            /> :
                                                            <></>}
                                                    </> :
                                                    <>
                                                        {boardMatchesSearch(campaign.boards[b.vendorId], this.state.search, this.state.filters) ?
                                                            <BoardCard
                                                                selectBoard={this.selectBoard}
                                                                onHover={() => { this.setState({ hoveredId: b.vendorId }) }}
                                                                leaveHover={() => { if (this.state.hoveredId === b.vendorId) this.setState({ hoveredId: "" }) }}
                                                                boardKey={b.vendorId}
                                                                isOwner={isOwner}
                                                                updateBoard={this.updateBoard}
                                                                sidebarFormat={url.get("sidebarFormat")}
                                                                centerMap={this.centerMap}
                                                                key={index}
                                                                campaign={campaign}
                                                                board={campaign.boards[b.vendorId]}
                                                            /> :
                                                            <></>}
                                                    </>}
                                            </>
                                        )}
                                        {isOwner ?
                                            <Link target={"_blank"} to={`/campaign/${campaign._id}/upload`} className={"btn btn-primary mt-4 mb-4 d-block center mx-auto"}>+ Upload Media</Link>
                                        :<></>}
                                        <Footer/>
                                    </div> :<div className={"board-card-container"}>
                                        <p className={"text-center mt-5"}>No Outdoor Media Has Been Uploaded</p>
                                        {isOwner ?
                                            <Link target={"_blank"} to={`/campaign/${campaign._id}/upload`} className={"btn btn-primary mt-4 mb-4 d-block center mx-auto"}>+ Upload Media</Link>
                                            :<></>}
                                        <Footer/>
                                    </div>
                                }
                            </div>
                            { selectedBoard ? (
                                <div className={"selected-board"}>
                                    <div className={"campaign-header"}>
                                        <h1>{campaign.boards[selectedBoard].fields["unit #"]} ~ {campaign.boards[selectedBoard].fields.description}</h1>
                                        <p>{campaign.boards[selectedBoard].fields["h x w"]} - {campaign.boards[selectedBoard].fields["media format"]}</p>
                                        <span onClick={()=>this.selectBoard()} className={"close-icon"}> </span>
                                    </div>
                                    <div className={"selected-board-container"}>
                                        <SelectedBoard
                                            toggleFullScreenImage={this.toggleFullScreenImage}
                                            turnOffPins={this.turnOffPins}
                                            togglePOIsPins={this.togglePOIsPins}
                                            toggleCompliancePins={this.toggleCompliancePins}
                                            board={campaign.boards[selectedBoard]}
                                            boardKey={selectedBoard}
                                            updateBoard={this.updateBoard}
                                            isOwner={isOwner}
                                            campaign={campaign}/>
                                    </div>
                                </div>
                            ) : (
                                <div className={"selected-board width-0"}>
                                </div>
                            )}
                            <div className={"sidebar-format-menu"}>
                                <i role={"button"}
                                   className={"fa-solid fa-border-all " + (url.get("sidebarFormat") === "grid" && " active")}
                                   onClick={()=>this.setQueryParam("sidebarFormat", "grid")}
                                ></i>
                                <br/>
                                <i role={"button"}
                                   className={"fa-solid fa-list " + ((url.get("sidebarFormat") === "rows" || !url.get("sidebarFormat")) && " active")}
                                   onClick={()=>this.setQueryParam("sidebarFormat", "rows")}
                                ></i>
                                <br/>
                                <i role={"button"}
                                   className={"fa-solid fa-angle-left " + (url.get("sidebarFormat") === "minimized" && " active")}
                                   onClick={()=>this.setQueryParam("sidebarFormat", "minimized")}
                                ></i>
                            </div>
                        </div>
                        <div className={"map-container " + url.get("sidebarFormat") }>
                            <MapContainer
                                showCompliance={this.state.showCompliance}
                                showPOIs={this.state.showPOIs}
                                selectBoard={this.selectBoard}
                                selectedBoard={campaign.boards ? campaign.boards[selectedBoard]:undefined}
                                center={this.state.center}
                                centerMap={this.centerMap}
                                boards={
                                    (url.get("sidebarFormat") === "rows" || !url.get("sidebarFormat")) ?
                                        this.state.groupedBoards :
                                        campaign.boards
                                }
                                campaign={campaign}
                                isOwner={isOwner}
                                isPrimaryOwner={isPrimaryOwner}
                                currentUserId={user?._id}
                                search={this.state.search}
                                filters={this.state.filters}
                                hoveredId={this.state.hoveredId}
                                updateBoard={this.updateBoard}
                                overlays={this.state.overlays}
                                accidents={this.state.accidents}
                                refetchCampaign={this.getCampaignAPI.bind(this)}
                            />
                        </div>
                    </>) : (
                    <div className={"full-loading-screen"}>
                        <div>
                            <img src={loadingSvg}  alt={"loading icon"}/>
                            { campaign ? <div>
                                <h4>Uploading Media...</h4>
                                <p><i>{campaign.boardsUploaded}/{campaign.totalBoards} Uploaded</i></p>
                                <br/>
                                <br/>
                                <div className={"loading-bar"}>
                                    {/*<div style={{width: campaign.boardsUploaded / campaign.totalBoards * 100 + "%"}}/>*/}
                                    <div style={{width:campaign.boardsUploaded/campaign.totalBoards * 100 + "%"}}/>
                                </div>
                                {/*<p>{campaign.boardsUploaded} / {campaign.totalBoards}</p>*/}
                            </div>: <h4>Finding Campaign...</h4>}
                                </div>
                    </div>
                ) }
            </div>
            { campaign && campaign.boards && campaign.boards[selectedBoard] ? <Modal show={this.state.fullScreenImg} dialogClassName="modal-100" onHide={this.toggleFullScreenImage}>
                <Modal.Header closeButton >
                    <Modal.Title>{campaign.boards[selectedBoard].fields["unit #"]} ~ {campaign.boards[selectedBoard].fields.description}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Carousel>
                        {campaign.boards[selectedBoard].images ? campaign.boards[selectedBoard].images.map(function (im) {
                            return <Carousel.Item>
                                {(()=>{
                                    if (getUrlExtension(im) === "pdf") {
                                        return <>
                                            <embed src={im} className={"w-100"} style={{height:"80vh"}}/>
                                        </>
                                    } else if (im && im.length) {
                                        return <img src={im} alt="billboard header" className={"w-100"}/>
                                    }
                                })()}
                            </Carousel.Item>
                        }):<></>}
                    </Carousel>
                </Modal.Body>
            </Modal>:""}
        </>
    }
}

function FormatDate(date){
    let d = new Date(date);
    return (d.getMonth()+1) + "/" + d.getDate() + "/" + d.getFullYear();
}
